import { DeliveryOptionsProvider } from "store/deliveryOptionsStore";
import { PlaceProvider } from "store/placeStore";
import Place from "routes/place-route/components/Place";
import { ProtectedRoutes } from "types/routes";
import RouteWrapper from "components/route-wrapper/RouteWrapper";
import ProtectedRoute from "components/protected-route/ProtectedRoute";

function PlaceRoute() {
	return (
		<PlaceProvider>
			<DeliveryOptionsProvider>
				<RouteWrapper route={ProtectedRoutes.PLACE}>
					<ProtectedRoute route={ProtectedRoutes.PLACE}>
						<Place />
					</ProtectedRoute>
				</RouteWrapper>
			</DeliveryOptionsProvider>
		</PlaceProvider>
	);
}

export default PlaceRoute;
